import { VendorLoginPage } from "@/features/vendor-app/pages/VendorLoginPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/login")({
	validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
		redirect:
			typeof search.redirect === "string" &&
			search.redirect.length > 0 &&
			search.redirect.startsWith("/vendor")
				? search.redirect
				: undefined,
	}),
	component: VendorLoginPage,
});
